import { Component } from '@angular/core';

interface ProductCategoryCard {
    title: string;
    route: string[] | string;
    icon: string;
}

@Component({
    selector: 'app-product-category-cards',
    templateUrl: './product-category-cards.component.html',
    styleUrls: ['./product-category-cards.component.scss'],
    standalone: false,
})
export class ProductCategoryCardsComponent {
    public cards: ProductCategoryCard[] = [
        {
            title: 'Handy&shy;versicherung',
            route: '/produkte/handyversicherung',
            icon: '-handy',
        },
        {
            title: 'Tablet&shy;versicherung für die Schule',
            route: '/produkte/tablet-versicherung-plus',
            icon: '-tablet_schueler',
        },
        {
            title: 'Elektronik&shy;versicherung',
            route: '/produkte/elektronikversicherung',
            icon: '-elektronik',
        },
    ];
}
